module.exports = __webpack_public_path__ + "img/picture_spjj.92cad04a.png";